import { createSearchParams } from "react-router-dom";
import { useGetRecommendedDoseQuery } from "src/api/services/titrationApi";
import { Paths } from "src/constants/paths";

export const useGenerateOTRefillLink = () => {
  const { data } = useGetRecommendedDoseQuery();

  if (data == null) return null;

  const params = createSearchParams({
    dosage: data.dosage,
    id: data.price.stripe_id,
    amount: String(data.price.amount),
  }).toString();

  return {
    path: `/${Paths.ADD_ONS}/${data.product.slug}`,
    searchParams: params,
  };
};
